import { render, staticRenderFns } from "./Foreigner.vue?vue&type=template&id=c3541f66"
import script from "./Foreigner.vue?vue&type=script&lang=js"
export * from "./Foreigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports